var business = {
  init : function () {
    $(document).ready(function(){
      //通常のクリック時
      $('a[href^="#"]').click(function(e) {
        e.preventDefault();
        //ページ内リンク先を取得
        var href= $(this).attr("href");
        //リンク先が#か空だったらhtmlに
        var hash = href == "#" || href == "" ? 'html' : href;
        //スクロール実行
        scrollToAnker(hash);
        //リンク無効化
      });

      // 関数：スムーススクロール
      // 指定したアンカー(#ID)へアニメーションでスクロール
      function scrollToAnker(hash) {
        var target = $(hash);
        var position = target.offset().top;
        $('body,html').stop().animate({scrollTop:position}, 500);
      }

    })

  }
}


if($('#p-business')[0]){
    business.init();
}
